export default __webpack_public_path__ + "static/media/ic_product-features.6c38ece7.svg";